import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPut } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state';
import { API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_PATH_KEY } from '@/swagger/constants/surveys-keys';
import { API_PUT_SURVEY_CAMPAIGN_BY_ID_CALL, KEY_PUT_SURVEY_CAMPAIGN_BY_ID } from '../constats';
import { MOCK_RESPONSE_PUT_SURVEY_CAMPAIGN_BY_ID } from '../mocks';

type RequestPathPutSurveyCampaignById = GenericPut<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_PATH_KEY
>['request']['path'];

type RequestBodyPutSurveyCampaignById = GenericPut<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_PATH_KEY
>['request']['body'];

type ResponsePutSurveyCampaignById = GenericPut<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_PATH_KEY
>['response']['body'];

type CallParamsPutSurveyCampaignById = Omit<RequestPathPutSurveyCampaignById, 'organizationId'> &
  RequestBodyPutSurveyCampaignById & {
    successSaga?: CallbackSaga;
    errorSaga?: CallbackSaga;
  };

export type CallResponsePutSurveyCampaignById = ResponsePutSurveyCampaignById;

type CallErrorPutSurveyCampaignById = GenericApiError;

type CallSelectorsPutSurveyCampaignById = unknown;

export const putSurveyCampaignByIdCall = createGeneralCall<
  CallParamsPutSurveyCampaignById,
  CallResponsePutSurveyCampaignById,
  CallErrorPutSurveyCampaignById,
  CallSelectorsPutSurveyCampaignById
>({
  id: KEY_PUT_SURVEY_CAMPAIGN_BY_ID,
  method: 'put',
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_PUT_SURVEY_CAMPAIGN_BY_ID_CALL(org, payload.id);
    },
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_PUT_SURVEY_CAMPAIGN_BY_ID
    : undefined,
});
